import { Label, Stack } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';
import * as React from 'react';
import {
  getExtendedInfoDisplayBackgroundStyles, getExtendedInfoDisplayStyles,
  getLabelStyles, getLabelContainerStyles, TextClick, TextCliping, TextFontStyle
} from './HostAppInfoBar.styles';
import { ChangeEvent } from '../../stores/utils';
import { HostAppInfoBarManager } from './HostAppInfoBarManager';
import { HostAppUtil } from '../../../backend/office-js/HostAppUtil';
import { HostAppName } from '../../../backend/office-js/HostAppSettings';
import { isEmptyString } from '../../../utils/utils';

export interface HostAppInfoBarProps {
  type: 'HostAppInfoBarProps';
  marginLeft: number;
  marginRight: number;
  isClickable: boolean;
}

export interface ExtendedInfo {
  keyString: string;
  valueString: string;
}

interface ExtendedViewProps {
  type: 'ExtendedViewProps';
  keyString: string;
  valueString: string;
}

export interface HostAppInfoBarState {
  showHoverWindow: boolean;
  primaryTitle: string;
  secondaryTitle: string;
  extendedInfoList: Array<ExtendedInfo>;
}

const DEFAULT_MARGIN_RIGHT = 20;

export class HostAppInfoBar extends React.PureComponent<HostAppInfoBarProps, HostAppInfoBarState> {

  private hostAppInfoBarManager: HostAppInfoBarManager;

  constructor(props: HostAppInfoBarProps) {
    super(props);
    this.hostAppInfoBarManager = new HostAppInfoBarManager();
  }

  public componentDidMount() {
    this.hostAppInfoBarManager.on(ChangeEvent.Change, this.handleUpdate);
  }

  public componentWillUnmount() {
    this.hostAppInfoBarManager.removeAllListeners();
  }

  public render() {
    const { marginLeft, marginRight, isClickable } = this.props;
    this.state = this.hostAppInfoBarManager.getState();

    return (
      <div className='HostAppInfoBar'>
        <Stack horizontal styles={getLabelContainerStyles('0px ' + (marginRight+'px') + ' 10px ' + (marginLeft+'px'))}>
          {!isEmptyString(this.state.primaryTitle) ? <Label styles={getLabelStyles(
            AppLayoutSettings.AppFontSize.mediumFontSizePx,
            AppLayoutSettings.getAppColorContainer().mediumLabelColor.value)} >
            {this.state.primaryTitle}</Label> : null}
          {(!isEmptyString(this.state.primaryTitle) && !isEmptyString(this.state.secondaryTitle)) ? <Label styles={getLabelStyles(
            AppLayoutSettings.AppFontSize.mediumFontSizePx,
            AppLayoutSettings.getAppColorContainer().mediumLabelColor.value, TextCliping.Not_Required, TextFontStyle.Bold)} >
            {": "}</Label> : null}
          {!isEmptyString(this.state.secondaryTitle) ? <Label id={'HostAppInfoBarSecondaryTitle'} styles={getLabelStyles(
            AppLayoutSettings.AppFontSize.mediumFontSizePx,
            AppLayoutSettings.getAppColorContainer().linkColor.value,
            TextCliping.Ellipsis, TextFontStyle.Bold,
            isClickable ? TextClick.Required : TextClick.Not_Required)}
            onMouseEnter={this.hostAppInfoBarManager.handleOnHover} onMouseLeave={this.hostAppInfoBarManager.handleOnHoverDone} onClick={this.hostAppInfoBarManager.handleOnClick} tabIndex={0}>
            {this.state.secondaryTitle}</Label> : null}

        </Stack>
        {this.state.showHoverWindow ?
          <Stack horizontal styles={getExtendedInfoDisplayBackgroundStyles(marginLeft, marginRight)}>
            <Stack styles={getExtendedInfoDisplayStyles()}>

              {this.state.extendedInfoList.map((extendedInfo) => (
                <ExtendedViewLabel
                  type={'ExtendedViewProps'}
                  keyString={extendedInfo.keyString}
                  valueString={extendedInfo.valueString} />
              ))}
            </Stack>
          </Stack> : null}
      </div>
    );
  }

  private handleUpdate = (): void => {
    this.forceUpdate();
  }
}

const ExtendedViewLabel: React.FunctionComponent<ExtendedViewProps> = (props: ExtendedViewProps): JSX.Element => {

  const { keyString, valueString } = props;
  return (
    <Stack horizontal styles={getLabelContainerStyles('0px 1px 0px 1px')}>
      {!isEmptyString(keyString) ? <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Not_Required, TextFontStyle.Bold)}>{keyString}</Label> : null}
      {(!isEmptyString(keyString) && !isEmptyString(valueString)) ? <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Not_Required, TextFontStyle.Bold)}>{":  "}</Label> : null}
      {!isEmptyString(valueString) ? <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Break_word, TextFontStyle.Bold)}>{valueString}</Label> : null}
    </Stack>
  );
}

export function getHostAppInfoBar(marginLeft: number = 0, marginRight: number = DEFAULT_MARGIN_RIGHT) {
  switch (HostAppUtil.GetHostAppName()) {
    case HostAppName.ONENOTE:
      return (
        <HostAppInfoBar
          type={'HostAppInfoBarProps'}
          marginLeft={marginLeft}
          marginRight={marginRight == 0 ? DEFAULT_MARGIN_RIGHT : marginRight}
          isClickable={true}
        />
      )
    default:
      return null;
  }
}